<app-skill-list
  [reloadVersion]="reloadVersion"
  (addNew)="onAddNew()"
  (deleted)="onDeleted()" />

<app-skill-form-dialog
  [visible]="showFormDialog"
  (visibleChange)="onDialogHide()"
  (saved)="onSaved()" />
